var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h6',{staticClass:"fw-b"},[_vm._v(_vm._s(_vm.$t('pages.patients.discountcodes')))])]),_c('div',{staticClass:"col-12"},[_c('el-table',{staticClass:"mb-32",attrs:{"rows":_vm.patient.payments,"structure":_vm.discountCodesStructure,"editable":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }